import React from 'react';
import './components.sass'

const Footer = () => {
    return (
        <footer>
            <img
                style={{width: '100%', alignSelf: 'flex-end'}}
                src={'rocket_label.png'}
                alt={''}/>
        </footer>
    );
};

export default Footer;